export default "__VITE_ASSET__B78uY_Wa__"